















































































































import { Component, Vue } from 'vue-property-decorator'
import SpHeader from '@/app/components/Common/SpHeader.vue'
import router from '../router'
import CommonHeader from '@/app/components/Common/Header.vue'

@Component({
  components: {
    CommonHeader,
    SpHeader
  }
})
export default class ErrorPage extends Vue {
  private notfonund: boolean = true
  private authError: boolean = false
  private serverError: boolean = false
  private showHeaderMenu: boolean = false

  created () {
    if (this.$store.state.routeState.route !== '/sp/login') {
      this.showHeaderMenu = true
    }

    if (this.$store.state.routeState.errorFlag === 1) {
      this.notfonund = true
      this.authError = false
      this.serverError = false
    } else if (this.$store.state.routeState.errorFlag === 2) {
      this.notfonund = false
      this.authError = true
      this.serverError = false
    } else if (this.$store.state.routeState.errorFlag === 3) {
      this.notfonund = false
      this.authError = false
      this.serverError = true
    }
  }

  private doReload () {
    this.$router.push(this.$store.state.routeState.route).catch(e => {})
  }
}
